const rpContractStatus = Object.freeze({
  NotAvailable: -1,
  Unset: 0,
  New: 1,
  Submitted: 2,
  Approved: 3,
  Denied: 4,
  ApprovedContractInformation: 5,
  DeniedContractInformation: 6,
  Signed: 7,
  ContractCanceled: 8,
  ContractAmended: 9,
  InSigningProcess: 10,
});

export const rpContractStatusColor = Object.freeze({
  [rpContractStatus.NotAvailable]: 'orange-light',
  [rpContractStatus.New]: 'gray',
  [rpContractStatus.Submitted]: 'yellow',
  [rpContractStatus.Approved]: 'green-light',
  [rpContractStatus.Denied]: 'brown',
  [rpContractStatus.ApprovedContractInformation]: 'green-light',
  [rpContractStatus.DeniedContractInformation]: 'brown',
  [rpContractStatus.Signed]: 'orange-light',
  [rpContractStatus.ContractCanceled]: 'violet',
  [rpContractStatus.ContractAmended]: 'green-light',
  [rpContractStatus.SignatureProcess]: 'green-light',
  [rpContractStatus.InSigningProcess]: 'tea-rose',
});

export default rpContractStatus;
